var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from "react";
import * as classNames from "classnames";
var Checkbox = function (_a) {
    var label = _a.label, className = _a.className, otherProps = __rest(_a, ["label", "className"]);
    return (React.createElement("span", { className: "wds-checkbox" },
        React.createElement("input", __assign({ type: "checkbox", className: classNames(className, "wds-checkbox__native") }, otherProps)),
        React.createElement("span", { className: "wds-checkbox__faux" }),
        React.createElement("label", { className: "wds-checkbox__label", htmlFor: otherProps.id }, label)));
};
export default Checkbox;
//# sourceMappingURL=Checkbox.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@sm/smapply-ui/dist/es/components/Checkbox/Checkbox.js
// module id = 1767
// module chunks = 17